import React from 'react';
import { render } from 'react-dom';
import ShareModal from '../../components/share-modal';
import { getElementPosition } from '../../utils/position';
import { trackShareButton } from './tracking';

// Share modal.
const modal = document.getElementById('modal');

// Bind event listener to document since cards can be dynamically injected.
document.addEventListener('click', async (event) => {
  const { target, target: { classList } } = event;

  // Was the click on the share button?
  if (classList && classList.contains('share-button')) {
    const {
      id,
      title,
      section,
      tag,
      type,
      url,
      videoId,
      videoNetworkId,
    } = { ...(target.dataset) };

    // Props for share component.
    const props = {
      title,
      url,
      videoNetworkId,
      videoId,
    };

    // Render the share modal.
    render(<ShareModal {...props} />, modal);

    // Toggle class to make modal visible.
    modal.classList.toggle('active');

    // Get card position.
    const position = getElementPosition(target, '.share-button');

    // Track the share button click.
    trackShareButton(
      id,
      title,
      url,
      type,
      section,
      tag,
      position
    );
  }
});
